import React, { useRef, useEffect } from 'react';

// Real-time canvas waveform. If `analyser` provided, draws live audio; else animated idle bars.
export const Waveform = ({ analyser, active = false, color = '#3EB489', height = 56 }) => {
  const canvasRef = useRef();
  const rafRef = useRef();

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext('2d');
    const dpr = window.devicePixelRatio || 1;
    const resize = () => {
      canvas.width = canvas.offsetWidth * dpr;
      canvas.height = height * dpr;
      ctx.scale(dpr, dpr);
    };
    resize();
    let t = 0;
    const dataArray = analyser ? new Uint8Array(analyser.frequencyBinCount) : null;
    const draw = () => {
      const w = canvas.offsetWidth, h = height;
      ctx.clearRect(0, 0, w, h);
      const bars = 48;
      const bw = w / bars;
      for (let i = 0; i < bars; i++) {
        let amp;
        if (analyser && active) {
          analyser.getByteFrequencyData(dataArray);
          amp = (dataArray[Math.floor(i * dataArray.length / bars)] / 255) * h * 0.9;
        } else {
          amp = active
            ? (Math.sin(t * 0.15 + i * 0.4) * 0.5 + 0.5) * h * 0.6 + 4
            : (Math.sin(i * 0.5) * 0.5 + 0.5) * h * 0.22 + 3;
        }
        const x = i * bw + bw * 0.2;
        const bh = Math.max(2, amp);
        ctx.fillStyle = color;
        ctx.globalAlpha = active ? 0.9 : 0.4;
        ctx.beginPath();
        ctx.roundRect(x, (h - bh) / 2, bw * 0.6, bh, 3);
        ctx.fill();
      }
      t += 1;
      rafRef.current = requestAnimationFrame(draw);
    };
    draw();
    return () => cancelAnimationFrame(rafRef.current);
  }, [analyser, active, color, height]);

  return <canvas data-testid="voice-note-waveform" ref={canvasRef} style={{ width: '100%', height }} />;
};
